
export class CustomPropertiesInformationBar implements ICustomPropertiesInformationBar {
  firstLevelInformation ?: string;
  secondLevelInformation ?: string;
  classBarStyle ?: string;
  constructor(){
    this.firstLevelInformation = '';
    this.secondLevelInformation = '';
    this.classBarStyle = '';
  }
}
